module.exports = __webpack_public_path__ + "img/gree.4a25757e.png";